(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["p5r-build-promo"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var frames = document.querySelectorAll('[data-build-slides]');
    frames.forEach(function (frame) {
      if (frame.dataset.slidesReady) return;
      frame.dataset.slidesReady = '1';
      var slides = frame.querySelectorAll('.build-promo__slide');
      if (slides.length < 2) return;
      var index = 0;
      slides.forEach(function (slide, n) { slide.classList.toggle('is-active', n === 0); });
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      setInterval(function () {
        slides[index].classList.remove('is-active');
        index = (index + 1) % slides.length;
        slides[index].classList.add('is-active');
      }, 2500);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
